export const ROLES = [
    "Superadministrador",
    "Administrador",
    "Recepcionista",
    "Monitoreo",
    "Room Service",
    "Bartender",
    "Mantenimiento",
    "Valet Parking",
    "Mesero",
    "Cocina",
]

export const FUNCIONES: { nombre: string; acceso: boolean[] }[] = [
    { nombre: "Panel de habitaciones", acceso: [true, true, true, true, true, false, true, true, false, false] },
    { nombre: "Drawer", acceso: [true, true, true, true, false, true, true, true, false, false] },
    { nombre: "Reservaciones", acceso: [true, true, true, true, true, true, true, true, false, false] },
    { nombre: "Personal", acceso: [true, true, true, true, false, true, false, false, false, false] },
    { nombre: "Room service", acceso: [true, true, true, false, true, true, false, false, true, false] },
    { nombre: "Restaurante", acceso: [true, true, true, true, false, true, false, false, true, false] },
    { nombre: "Panel de preparacion", acceso: [true, true, true, true, true, true, false, false, true, true] },
    { nombre: "Lista de espera", acceso: [true, true, true, true, false, true, false, true, false, false] },
    { nombre: "Pantalla de disponibilidad", acceso: [true, true, true, true, false, true, false, true, false, false] },
    { nombre: "Gastos", acceso: [true, true, true, false, false, false, false, false, false, false] },
    { nombre: "Cortes", acceso: [true, true, true, false, false, false, false, false, false, true] },
    { nombre: "Inventario", acceso: [true, true, true, true, false, false, false, false, false, false] },
    { nombre: "Incidencias", acceso: [true, true, true, true, true, true, true, true, false, false] },
    { nombre: "Propinas", acceso: [true, true, true, false, false, false, false, false, false, false] },
    { nombre: "Reportes", acceso: [true, true, true, true, false, false, true, true, false, false] },
    { nombre: "Easyrewards", acceso: [true, true, true, true, true, false, false, true, false, false] },
    { nombre: "Multihotel", acceso: [true, false, false, false, false, false, false, false, false, false] },
    { nombre: "App Mobile", acceso: [true, false, false, false, false, false, false, false, false, false] },
]